export const SET_ERROR = 'SET_ERROR'
export const SET_ITEMS = 'SET_ITEMS'
export const SET_ITEM = 'SET_ITEM'
export const ADD_ITEM = 'ADD_ITEM'
export const SET_DATA = 'SET_DATA'
export const REMOVE_BY_ID = 'REMOVE_BY_ID'
export const SET_USAGE = 'SET_USAGE'
export const RESET = 'RESET'
export const TOGGLE_GTIN = 'TOGGLE_GTIN'